<template>
   <div class="ui centered grid">
    <div v-for="note in noteList" :key="note.uuid" class="row">
        <div v-if="note.uuid==editNote" v-bind:class="{sixteen:!show_item_ids,fourteen:show_item_ids,wide:true,column:true}">
            <TheNoteForm v-bind:new_note="false" v-bind:note_id="note.uuid" v-bind:items="note.items" @cancelNote="cancel" @submitNote="submited"></TheNoteForm>
        </div>
       
        <div v-if="note.uuid!=editNote" v-bind:class="{opened:note.uuid!=editNote,closed:note.uuid==editNote,sixteen:!show_item_ids,fourteen:show_item_ids,wide:true,column:true}" style="padding:15px 15px 0px 15px">
            <div class="ui segment" v-bind:style="{'background-color':note.note_color}">
                {{note.note}}
            </div>
        </div>
         <div v-if="show_item_ids" class="two wide column" style="padding:15px 0px 0px 15px">
            <div v-if="note.hasOwnProperty('items')">
                <div v-for="item in note.items" :key="note.uuid+'-'+item">
                    <router-link v-bind:to="'/item/'+item">{{item}}</router-link>
                </div>
            </div>
        </div>
        <div  v-bind:class="{thirteen:!show_item_ids,eleven:show_item_ids,wide:true,column:true}" style="font-size:12px;color:rgb(130, 130, 130);padding:5px 0px 0px 20px">
            <table style="">
                <tr>
                    <td>Created</td>
                    <td><span class="italic">{{formatDate(note.created)}}</span></td>
                    <td>by <span class="italic">{{note.created_by}}</span></td>
                </tr>
                <tr v-if="note.created!=note.updated">
                    <td>Updated</td>
                    <td><span class="italic">{{formatDate(note.updated)}}</span></span>
                    </td>
                    <td>by <span class="italic">{{note.updated_by}}</span></td>
                </tr>
            </table>
        </div>
        <div v-bind:class="{three:true,wide:true,column:true}" style="padding:5px 15px 0px 0px;text-align:right">
            <i class="edit outline icon" style="cursor:pointer" v-on:click="edit(note.uuid)"></i>&nbsp;&nbsp;<i class="trash alternate outline icon" style="cursor:pointer" v-on:click="delete_note(note.uuid)"></i>
        </div>
      <div v-if="show_item_ids" class="two wide column">
            
        </div>
    </div>

    <div class="ui mini modal" id="deleteConfirm">
        <div class="content">
            <p>Delete the note</p>
        </div>
        <div class="actions">
            <div class="ui red cancel inverted button">
                <i class="remove icon"></i> No
            </div>
            <div class="ui green ok inverted button">
                <i class="checkmark icon"></i> Yes
            </div>
        </div>
    </div>
</div>


</template>


<script>
    import TheNoteForm from '../components/TheNoteFormV2.vue'
    export default {
        props: ['loadedList', 'primary_item', 'related_items', 'show_item_ids','show_related_ids','mynotes'],
        components: {
            TheNoteForm
        },
        data() {
            return {
                editNote: "",
                noteList: null
            }
        },
        mounted() {
            this.loadData();
        },
        watch: {
            loadedList: function() {
                this.loadData();
                //this.noteList = this.loadedList;
            },
            primary_item:function(){
                this.loadData();
            }
        },
        methods: {
            formatDate: function(d) {
                var date = new Date(d);
                var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                var dd = ('0' + date.getDate()).slice(-2);
                var mon = months[date.getMonth()];
                var yyyy = date.getFullYear();
                var hh = ('0' + date.getHours()).slice(-2);;
                var mm = ('0' + date.getMinutes()).slice(-2);
                return dd + "-" + mon + "-" + yyyy + " " + hh + ":" + mm
            },
            delete_note: function(uuid) {
                // $emit('deleteNote',uuid)  
                var myThis = this;
                $('#deleteConfirm').modal({
                    onApprove: function() {
                        axios
                            .delete('/api/note/' + uuid)
                            .then(response => {
                                if (response.status == 200) {
                                    //    myThis.showMessage('positive', "Note deleted succesfully.");
                                    //    myThis.hideMessage(5);
                                }
                                else {
                                    //   myThis.showMessage('negative', "Cannot delete note. Server response: " + response.status);
                                }
                                myThis.loadData();
                            });
                    }
                }).modal('show');
            },
            edit: function(uuid) {
                this.editNote = uuid;
            },
            cancel: function() {
                this.editNote = "";
            },
            submited: function(respnse) {
                this.editNote = "";
                this.loadData();
            },
            loadData: function() {
                var query="";
                if (this.show_related_ids){
                    query="?related_items="+this.related_items;
                }
                if (this.mynotes){
                     query="?mynotes=true";
                }
                axios
                    .get('/api/notes/' + this.primary_item+query)
                    .then(response => {
                        this.noteList = response.data;
                    });
            },
        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .opened {
        display: block;
    }

    .closed {
        display: none;
    }

    .italic {
        font-style: italic;
    }

    TD {
        padding: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheNoteList.vue